import { useState } from "react"
import { Button } from "src/@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/@/components/ui/dialog"
import { Input } from "src/@/components/ui/input"
import { Label } from "src/@/components/ui/label"
import { RowInput } from "src/components/forms/RowInput"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/@/components/ui/select"

// Cores do shadcn/ui (Tailwind CSS)
// Apenas cores padrão do shadcn/ui
const CORES_MAP = {
  slate: { nome: 'Cinza', tailwindClass: 'bg-slate-200' },
  orange: { nome: 'Laranja', tailwindClass: 'bg-orange-200' },
  yellow: { nome: 'Amarelo', tailwindClass: 'bg-yellow-200' },
  cyan: { nome: 'Ciano', tailwindClass: 'bg-cyan-200' },
  blue: { nome: 'Azul', tailwindClass: 'bg-blue-200' },
  purple: { nome: 'Roxo', tailwindClass: 'bg-purple-200' },
  pink: { nome: 'Rosa', tailwindClass: 'bg-pink-200' },
  red: { nome: 'Vermelho', tailwindClass: 'bg-red-200' }
}

const CORES_PREDEFINIDAS = Object.keys(CORES_MAP).map(key => ({
  value: key, // Nome da cor (ex: "red", "slate", "rose")
  label: key,
  nome: CORES_MAP[key].nome,
  tailwindClass: CORES_MAP[key].tailwindClass
}))

// Função para obter classe Tailwind a partir do nome da cor
export function getColorClass(colorName) {
  if (!colorName) return 'bg-gray-500'
  // Se for um hex antigo (compatibilidade), retorna vazio para usar inline style
  if (colorName.startsWith('#')) return ''
  return CORES_MAP[colorName]?.tailwindClass || 'bg-gray-500'
}

// Função para converter hex antigo para nome de cor (compatibilidade)
export function convertHexToColorName(hex) {
  if (!hex || !hex.startsWith('#')) return hex // Já é um nome ou inválido
  // Se for hex antigo, retorna gray como padrão (não há mais mapeamento hex->nome)
  return 'gray'
}

// Função para determinar a cor do texto baseada no nome da cor
function getTextColor(colorName) {
  // Cores claras que precisam de texto preto
  const lightColors = ['yellow', 'amber', 'lime'];
  return lightColors.includes(colorName) ? 'text-black' : 'text-white';
}

export default function ModalTags({
  open,
  onClose,
  onSubmit,
  action,
  nome,
  changeNome,
  corHex, // Recebe o nome da cor (ex: "red", "slate")
  changeCorHex
}) {
  const corSelecionada = CORES_MAP[corHex]
  const colorClass = `${corSelecionada?.tailwindClass}` || 'bg-gray-500'

  return (
    <Dialog open={open} onOpenChange={onClose}>

      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {action === "Criar" ? "Nova Tag" : "Editar Tag"}
          </DialogTitle>

        </DialogHeader>
        <div className="grid gap-4 py-4">
          <RowInput
            label="Nome"
            input={<Input
              onChange={changeNome}
              value={nome}
            />}
          />
          <RowInput
            label="Cor"
            input={
              <Select value={corHex} onValueChange={changeCorHex}>
                <SelectTrigger>
                  <SelectValue placeholder="Selecione uma cor">
                    {corHex && corSelecionada && (
                      <div className="flex items-center gap-2">
                        <div
                          className={`w-5 h-5 rounded border border-gray-300 ${colorClass}`}
                        />
                        <span>
                          {corSelecionada.nome}
                        </span>
                      </div>
                    )}
                  </SelectValue>
                </SelectTrigger>
                <SelectContent>
                  {CORES_PREDEFINIDAS.map((cor) => (
                    <SelectItem key={cor.value} value={cor.value}>
                      <div className="flex items-center gap-2">
                        <div
                          className={`w-5 h-5 rounded border border-gray-300 flex-shrink-0 ${cor.tailwindClass}`}
                        />
                        <span>{cor.nome}</span>
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            }
          />

          {/* Preview da etiqueta */}
          <div className="pt-2">
            <Label className="text-sm text-gray-600 mb-2 block">Preview</Label>
            <div className="flex items-center gap-2 p-3 border border-gray-200 rounded-md bg-gray-50">
              <span
                className={`inline-flex text-gray-800 p-1 items-center rounded-sm text-xs font-medium ${colorClass} ${getTextColor(corHex)}`}
              >
                {nome || 'Nome da etiqueta'}
              </span>
              <span className="text-xs text-gray-500">
                Como ficará a etiqueta
              </span>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={onSubmit}>{action === "Criar" ? "Criar" : "Salvar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
